<template>
  <div class="row-line">
    <span
      class="empty-tips"
      v-t="'home.empty'"
    />
    <mm-button
      class="empty-buy-button"
      type="primary"
      @click="$emit('onBuy')"
      v-if="!isTaiwanClient && !isJapan"
    >
      <span v-t="'home.buy'" />
    </mm-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RenderEmpty',
  computed: {
    ...mapGetters('main', ['isTaiwanClient']),
    isJapan() {
      return window.location.host.includes('okki.ai')
    },
  }
}
</script>
<style lang="scss" scoped>
  .row-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .empty-tips{
    font-size: 18px;
    line-height: 1;
    color: #5D5D5D;
  }
  .empty-buy-button{
    // position: absolute;
    // top: 50%;
    // right: 40px;
    // transform: translateY(-50%);
  }
</style>


